import { MAX_INDIVIDUAIS, NOMES_HABILIDADE, TREINO_PADRAO, habilidadesDe, type ChaveHabilidade, type FocoTreino, type IntensidadeTreino, type Treino } from '../core';
import { app, humano } from './app';
import { dialogo } from './dialogos';
import { esc } from './util';

const HABS = Object.keys(NOMES_HABILIDADE) as ChaveHabilidade[];
const FOCOS: [FocoTreino, string][] = [
  ['equilibrado', 'Equilibrado (cada posição treina o que precisa)'],
  ['fisico', 'Físico (recupera energia e protege de lesões)'],
  ...HABS.map((k): [FocoTreino, string] => [k, `Foco em ${NOMES_HABILIDADE[k]}`]),
];
const INTENSIDADES: [IntensidadeTreino, string][] = [
  ['leve', 'Leve (evolui menos, não cansa)'],
  ['normal', 'Normal'],
  ['pesada', 'Pesada (evolui mais, cansa e pode lesionar)'],
];

function treinoDoClube(): Treino {
  const c = humano();
  c.treino ??= TREINO_PADRAO();
  return c.treino;
}

/** Aba Treino: foco do time, intensidade e até 5 treinos individuais por habilidade. */
export function dlgTreino(): string {
  const c = humano();
  const t = treinoDoClube();
  const opc = <T extends string>(valor: T, itens: [T, string][]): string => itens.map(([v, n]) => `<option value="${v}" ${valor === v ? 'selected' : ''}>${esc(n)}</option>`).join('');
  const usados = new Set(t.individuais.map((x) => x.jogadorId));
  const linhas = t.individuais
    .map((x, i) => {
      const jogadores = c.elenco
        .filter((j) => j.id === x.jogadorId || !usados.has(j.id))
        .sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'))
        .map((j) => `<option value="${j.id}" ${j.id === x.jogadorId ? 'selected' : ''}>${esc(j.posicao)} · ${esc(j.nome)} (F:${j.overall})</option>`)
        .join('');
      const j = c.elenco.find((p) => p.id === x.jogadorId);
      const atual = j ? habilidadesDe(j)[x.habilidade] : 0;
      return `<div class="pl-linha"><label>Jogador<select data-ch="tr-ind-jog-${i}">${jogadores}</select></label>
        <label>Habilidade (atual ${atual})<select data-ch="tr-ind-hab-${i}">${opc(x.habilidade, HABS.map((k): [ChaveHabilidade, string] => [k, NOMES_HABILIDADE[k]]))}</select></label>
        <button type="button" class="btn peq" data-a="tr-ind-del" data-i="${i}" aria-label="Remover">✕</button></div>`;
    })
    .join('');
  return dialogo(
    'Treino',
    `<div class="dlg-tit amarelo">Treino de ${esc(c.nome)}</div>
    <div class="dlg-corpo plano">
      ${app.mensagem ? `<div class="aviso-bf dentro" role="status">${esc(app.mensagem)}</div>` : ''}
      <p class="cinza peq">O treino acontece a cada rodada. Cada ganho sobe uma habilidade em 1 e, a cada 5 ganhos, o jogador ganha +1 de força. Jovens evoluem mais; veteranos, bem menos.</p>
      <div class="controles-esc">
        <label>Foco do time:<select data-ch="tr-foco">${opc(t.foco, FOCOS)}</select></label>
        <label>Intensidade:<select data-ch="tr-int">${opc(t.intensidade, INTENSIDADES)}</select></label>
      </div>
      <div class="pn-tit verde"><span>Treino individual (${t.individuais.length}/${MAX_INDIVIDUAIS})</span></div>
      <p class="cinza peq">O jogador escolhido treina uma habilidade com ganho bem maior que o resto do time.</p>
      ${linhas || '<p class="cinza">Nenhum jogador em treino individual.</p>'}
      <button type="button" class="btn" data-a="tr-ind-add" ${t.individuais.length >= MAX_INDIVIDUAIS ? 'disabled' : ''}>+ Treino individual</button>
    </div>
    <div class="dlg-botoes"><button class="btn" data-a="fechar">Fechar</button></div>`,
    'grande',
  );
}

/** Mexe no plano de treino (jogo solo: já vale; online: a tela manda o plano ao servidor depois). Devolve true se mudou. */
export function treinoAcao(acao: string, d: DOMStringMap): boolean {
  const c = humano();
  const t = treinoDoClube();
  if (acao === 'tr-ind-add') {
    const livre = c.elenco.filter((j) => !t.individuais.some((x) => x.jogadorId === j.id)).sort((a, b) => a.idade - b.idade)[0];
    if (!livre || t.individuais.length >= MAX_INDIVIDUAIS) return false;
    t.individuais.push({ jogadorId: livre.id, habilidade: livre.posicao === 'G' ? 'gol' : livre.posicao === 'A' ? 'fin' : 'pas' });
    return true;
  }
  if (acao === 'tr-ind-del') {
    t.individuais.splice(Number(d.i), 1);
    return true;
  }
  return false;
}

export function treinoMudar(campo: string, valor: string): boolean {
  const t = treinoDoClube();
  if (campo === 'tr-foco') t.foco = valor as FocoTreino;
  else if (campo === 'tr-int') t.intensidade = valor as IntensidadeTreino;
  else if (campo.startsWith('tr-ind-')) {
    const [, , tipo, n] = campo.split('-');
    const item = t.individuais[Number(n)];
    if (!item) return false;
    if (tipo === 'jog') item.jogadorId = Number(valor);
    else if (tipo === 'hab') item.habilidade = valor as ChaveHabilidade;
  } else return false;
  return true;
}
